import * as React from 'react';
import * as ReactDOM from 'react-dom';

import App from './App';
import { AuthProvider } from "react-oidc-context";
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import { createBrowserHistory } from 'history';
import registerServiceWorker from './registerServiceWorker';
import { userManagerConfig } from './infrastructure/UserManager';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

export const store = configureStore(history);

ReactDOM.render(
    <Provider store={store}>
        <AuthProvider  {...userManagerConfig} onSigninCallback={() => {

            window.history.replaceState(
                {},
                document.title,
                window.location.pathname
            )
        }}

        >
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </AuthProvider >
    </Provider>,
    document.getElementById('root'));

registerServiceWorker();
